import Vue from 'vue';
import App from './App.vue';
import 'vue-material-design-icons/styles.css';
import router from './router';
import store from './store';
import './registerServiceWorker';

async function main() {
  await store.dispatch('VALIDATE');

  Vue.config.productionTip = false;

  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
}

main();
